var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Button, Field, FieldType } from '../../../elements';
import { inject } from 'mobx-react';
import cxs from 'cxs/component';
import Theme from '../../../Theme';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            uuid: '',
            collaborator: null,
            notFound: false
        };
        _this.handleUUID = function (name, value, column) {
            _this.setState({ uuid: value });
        };
        _this.handleFind = function () { return __awaiter(_this, void 0, void 0, function () {
            var collaborator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.state.uuid.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.store.collaboratorStore.getCollaborator(this.state.uuid)];
                    case 1:
                        collaborator = _a.sent();
                        if (collaborator)
                            this.setState({ collaborator: collaborator, notFound: false });
                        else
                            this.setState({ notFound: true, collaborator: null });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.handleAdd = function () {
            _this.props.store.collaboratorStore.create(_this.state.collaborator);
        };
        return _this;
    }
    default_1.prototype.render = function () {
        var _a = this.state, uuid = _a.uuid, collaborator = _a.collaborator, notFound = _a.notFound;
        return (React.createElement("div", { className: "mt-5" },
            React.createElement(Container, null,
                React.createElement(Row, { className: "align-items-center" },
                    React.createElement(Col, { md: 6, lg: 6 },
                        React.createElement(Field, { field: {
                                tooltip: 'Introduce aquí el código del colaborador',
                                name: 'uuid',
                                type: FieldType.Text,
                                value: uuid
                            }, onChange: this.handleUUID })),
                    React.createElement(Col, { className: "list-inline", md: 6, lg: 6 },
                        React.createElement(Button, { primary: true, loading: ['get@collaborators/'], onClick: this.handleFind }, "Buscar colaborador")))),
            notFound &&
                React.createElement("div", null,
                    "No encontrado ",
                    uuid),
            collaborator &&
                React.createElement("div", { className: "mt-5 mr-5 ml-5" /*style={{marginLeft: '30px', marginRight: '30px'}}*/ },
                    React.createElement(Container, null,
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 12 },
                                React.createElement(Field, { field: {
                                        name: 'tradename',
                                        type: FieldType.Label,
                                        value: collaborator.tradename,
                                        underline: false
                                    }, onChange: function () { } })),
                            React.createElement(Col, null,
                                React.createElement(Field, { field: {
                                        name: 'businessName',
                                        type: FieldType.Label,
                                        value: collaborator.businessName,
                                        underline: false,
                                    }, onChange: function () { } })),
                            React.createElement(Col, null,
                                React.createElement(Field, { field: {
                                        name: 'email',
                                        type: FieldType.Label,
                                        value: collaborator.email,
                                        underline: false,
                                    }, onChange: function () { } }))))),
            React.createElement(ButtonsBar, { className: "text-center", style: { height: '50px' } },
                React.createElement(Button, { disabled: !collaborator || notFound, primary: true, onClick: this.handleAdd }, "a\u00F1adir"))));
    };
    default_1 = __decorate([
        inject('store')
    ], default_1);
    return default_1;
}(Component));
export default default_1;
var ButtonsBar = cxs('div')({
    display: 'flex',
    width: '100%',
    position: 'absolute',
    bottom: 0,
    backgroundColor: Theme.color.background,
    borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    '> button': {
        flex: 'auto',
        borderRight: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
        ':last-child': {
            borderWidth: 0
        }
    },
    marginTop: Theme.size.space[2],
    // borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Collaborators/container/CollaboratorsFormCreate.tsx
// module id = 1564
// module chunks = 0